import React from 'react';
import styled from 'styled-components';

import { Modal } from '@ontruck/orc';

const ModalStyled = ({ className, ...props }) => <Modal contentClassName={className} {...props} />;

export default styled(ModalStyled)`
  && {
    max-height: 585px;
  }
`;
